module.exports = "<div>\n  <img [src]=\"data.img\" [alt]=\"\">\n  <mat-dialog-actions class=\"flex\">\n    <button mat-raised-button color=\"primary\" type=\"button\" mat-dialog-close=\"true\">{{'BTN_CLOSE' | translate}}</button>\n  </mat-dialog-actions>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/show-image-dialog/show-image-dialog.component.html
// module id = ./src/app/shared/components/show-image-dialog/show-image-dialog.component.html
// module chunks = main